import { render, staticRenderFns } from "./bootom.vue?vue&type=template&id=7d6810e2&scoped=true"
import script from "./bootom.vue?vue&type=script&lang=js"
export * from "./bootom.vue?vue&type=script&lang=js"
import style0 from "./bootom.vue?vue&type=style&index=0&id=7d6810e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6810e2",
  null
  
)

export default component.exports